import { useTranslation } from 'react-i18next';
import useUserPlatform from '@/hooks/use-user-platform';
import type { BrandTheme } from '@/models/configuration';
import { type ConfigurationState, useConfigurationStore } from '@/stores/configuration';
import { BRAND_STORAGE_KEY } from '@/utils/constants';

const brandSelector = (s: ConfigurationState) => s.envConfig.brand;

export function useBrand() {
  const { t } = useTranslation();
  const { isEmbedded } = useUserPlatform();
  const brand = useConfigurationStore(brandSelector);

  const theme = isEmbedded ? brandMappings[localStorage.getItem(BRAND_STORAGE_KEY) ?? ''] : brand?.theme;

  return {
    key: brand?.key,
    theme,
    name: brand ? t(`brands.${brand.key}.name`) : 'Chat',
    shortName: brand ? t(`brands.${brand.key}.short-name`) : 'Chat',
  };
}

const brandMappings: Readonly<Record<string, BrandTheme>> = {
  LSPCN: 'threetwoone',
  LSPVN: 'bonglan',
  LSPMO: 'eightk',
};
